export default {"src":"/_next/static/media/GBP.e87d6943.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};